define(function(require, exports, module) {
    'use strict';

    var replacer = require('util/replacer.util');
    var replacers = [
        require('replacers/totalcasino-theme/carousel/carousel.view'),
        require('replacers/totalcasino-theme/hot/hot.view'),
        require('replacers/totalcasino-theme/favorites/favorites.view'),
        require('replacers/totalcasino-theme/recent/recent.view'),
        require('replacers/totalcasino-theme/sticky-footer/base.sticky-footer.view'),
        require('replacers/bingo-promocode/totalcasino-theme/bingo.promocode.view'),
        require('replacers/totalcasino-theme/search/search.view'),
        require('replacers/totalcasino-theme/checkbox/checkbox.view'),
        require('replacers/panic-button/panic-button.view')
    ];

    replacers.forEach(replacer.register.bind(replacer));

    module.exports = replacer;
});
